<div name="main" class="p-8 flex flex-col sm:w-auto bg-white">
  <div class="md:px-16">
    <div>
      <div class="pb-4">
        <h2 class="text-4xl my-2 use-rhetorik-sans">Lease Renewal</h2>
      </div>
      <div class="flex box-border-active pb-4">
        <div class="col-span-1">
          <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">1/4</h2>
        </div>
        <div class="col-span-9">
          <h2 class="text-lg font-bold my-6">Contact Information</h2>
        </div>
      </div>
    </div>
    <form id="basic-info" #renewalContactInfoForm="ngForm" class="flex flex-col pt-8">
      <div>
        <mat-form-field class="w-full my-2">
          <mat-label>First Name</mat-label>
          <input matInput name="FirstName" id="FirstName" placeholder="First Name" required readonly
            [(ngModel)]="model.FirstName" #FirstName="ngModel">
          <mat-error>Please enter a name</mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field class="w-full my-2">
          <mat-label>Middle Name</mat-label>
          <input matInput name="MiddleName" id="MiddleName" placeholder="Middle Name" readonly
            [(ngModel)]="model.MiddleName" #MiddleName="ngModel">
        </mat-form-field>
      </div>
      <div>
        <mat-form-field class="w-full my-2">
          <mat-label>Last Name</mat-label>
          <input matInput name="LastName" id="LastName" required placeholder="Last Name" readonly
            [(ngModel)]="model.LastName" #LastName="ngModel">
          <mat-error>Please enter a name</mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field class="w-full my-2">
          <mat-label>Email Address</mat-label>
          <input matInput name="Email" id="Email" required email placeholder="Your Contact Email Address"
            [readonly]="model.IsLocked" [(ngModel)]="model.AlternativeEmail" #Email="ngModel">
          <mat-error>Please enter a valid email address</mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field class="w-full my-2">
          <mat-label>Home Phone</mat-label>
          <input matInput name="HomePhone" id="HomePhone" placeholder="Home Phone Number" required phone
            [readonly]="model.IsLocked" [(ngModel)]="model.HomePhone" #HomePhone="ngModel" mask="(999) 999-9999"
            #HomePhone="ngModel">
          <mat-error>Please enter a valid phone number</mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field class="w-full my-2">
          <mat-label>Cell Phone</mat-label>
          <input matInput name="CellPhone" id="CellPhone" placeholder="Cell Phone Number" required phone
            [readonly]="model.IsLocked" [(ngModel)]="model.CellPhone" #CellPhone="ngModel" mask="(999) 999-9999"
            #CellPhone="ngModel">
          <mat-error>Please enter a valid phone number</mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field class="w-full my-2">
          <mat-label>Drives License</mat-label>
          <input matInput name="DLNum" id="DLNum" required [(ngModel)]="model.DLNum" [readonly]="model.IsLocked"
            #DLNum="ngModel">
          <mat-error>Please fill out this field</mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field class="w-full my-2">
          <mat-label>State</mat-label>
          <mat-select name="DLState" id="DLState" required [(ngModel)]="model.DLState" [disabled]="model.IsLocked"
            #DLState="ngModel">
            <mat-option *ngFor="let state of states" [value]="state.value">
              {{state.label}}
            </mat-option>
          </mat-select>
          <mat-error>Please fill out this field</mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field class="w-full my-2">
          <mat-label>Vehicle Information</mat-label>
          <mat-select name="hasVehicle" id="hasVehicle" [disabled]="model.IsLocked" required
            [(ngModel)]="model.HasVehicles" (selectionChange)="forceAtLeastOneVehicle($event)" #hasVehicle="ngModel">
            <mat-option *ngFor="let hasVehicleOption of hasVehicleOptions" [value]="hasVehicleOption.value">
              {{hasVehicleOption.label}}
            </mat-option>
          </mat-select>
          <mat-error>Please fill out this field</mat-error>
        </mat-form-field>
      </div>
      <div id="children" class="md:pl-4">
        <div *ngFor="let vehicle of model.Vehicles; let i = index; trackBy:listTrack">
          <div class="flex flex-col" *ngIf="model.HasVehicles">
            <div>
              <mat-form-field class="w-full my-2">
                <mat-label>Vehicle Information</mat-label>
                <mat-select name="ResidentKey[{{i}}]" id="ResidentKey[{{i}}]" [options]="residents"
                  [disabled]="model.IsLocked" required [(ngModel)]="vehicle.ResidentKey" #ResidentKey="ngModel">
                  <mat-option *ngFor="let resident of residents" [value]="resident.value">
                    {{resident.label}}
                  </mat-option>
                </mat-select>
                <mat-error>Please fill out this field</mat-error>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field class="w-full my-2">
                <mat-label>Year</mat-label>
                <input matInput name="Year[{{i}}]" id="Year[{{i}}]" placeholder="Year" required
                  [readonly]="model.IsLocked" [(ngModel)]="vehicle.Year" #Year="ngModel">
                <mat-error>Please fill out this field</mat-error>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field class="w-full my-2">
                <mat-label>Make</mat-label>
                <input matInput name="Make[{{i}}]" id="Make[{{i}}]" rplaceholder="Make" required
                  [readonly]="model.IsLocked" [(ngModel)]="vehicle.Make" #Make="ngModel">
                <mat-error>Please fill out this field</mat-error>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field class="w-full my-2">
                <mat-label>Model</mat-label>
                <input matInput name="Model[{{i}}]" id="Model[{{i}}]" placeholder="Model" required
                  [readonly]="model.IsLocked" [(ngModel)]="vehicle.VehicleModel" #VehicleModel="ngModel">
                <mat-error>Please fill out this field</mat-error>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field class="w-full my-2">
                <mat-label>Color</mat-label>
                <input matInput name="Color[{{i}}]" id="Color[{{i}}]" placeholder="Color" required
                  [readonly]="model.IsLocked" [(ngModel)]="vehicle.Color" #Color="ngModel">
                <mat-error>Please fill out this field</mat-error>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field class="w-full my-2">
                <mat-label>License Plate Number</mat-label>
                <input matInput name="Plate[{{i}}]" id="Plate[{{i}}]" placeholder="License Plate Number" required
                  [readonly]="model.IsLocked" [(ngModel)]="vehicle.Plate" #Plate="ngModel">
                <mat-error>Please fill out this field</mat-error>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field class="w-full my-2">
                <mat-label>State</mat-label>
                <mat-select name="StateLicensePlate" id="StateLicensePlate" required [disabled]="model.IsLocked"
                  [(ngModel)]="vehicle.State" #DLState="ngModel">
                  <mat-option *ngFor="let state of states" [value]="state.value">
                    {{state.label}}
                  </mat-option>
                </mat-select>
                <mat-error>Please fill out this field</mat-error>
              </mat-form-field>
            </div>
            <div>
              <button *ngIf="!model.IsLocked" mat-button color="accent" (click)="onRemoveVehicleClick(vehicle)"
                style="color: #545859">REMOVE VEHICLE</button>
            </div>
          </div>
        </div>
        <div *ngIf="model.HasVehicles">
          <button *ngIf="!model.IsLocked" mat-button color="accent" (click)="onAddVehicleClick()"
            style="color: #545859">ADD ANOTHER VEHICLE</button>
        </div>
      </div>
      <re-captcha size="invisible" #invisible></re-captcha>
      <div class="text-right">
        <button *ngIf="!model.IsLocked" mat-flat-button color="primary" (click)="removeUnusedVehicles()"
          class="h-10 px-6 my-2" [disabled]="!renewalContactInfoForm.form.valid">CONTINUE</button>
        <button *ngIf="model.IsLocked" mat-flat-button color="primary" (click)="onUpdateSuccess()"
          class="h-10 px-6 my-2">CONTINUE</button>
      </div>
    </form>
  </div>
</div>
